import script from "./vehicleAuditList.vue?vue&type=script&setup=true&lang=js"
export * from "./vehicleAuditList.vue?vue&type=script&setup=true&lang=js"

import "./vehicleAuditList.vue?vue&type=style&index=0&id=0526bece&lang=css"

const __exports__ = script;

export default __exports__